import Box from '@mui/material/Box'
import MenuList from '@mui/material/MenuList'
import Typography from '@mui/material/Typography'
import { Theme, styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

interface YearDropdownRootProps {
  $isClickable?: boolean
}

export const YearDropdownRoot = styled(Box)<YearDropdownRootProps>`
  display: inline-flex;
  align-items: center;
  ${({ $isClickable }: { $isClickable?: boolean }) => ($isClickable ? 'cursor: pointer;' : '')}

  & > svg {
    fill: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
  }
`

interface YearDropdownItemLabelProps {
  $isSelected: boolean
  $isDisabled: boolean
}

export const YearDropdownItemLabel = styled(Typography)<YearDropdownItemLabelProps>`
  color: ${({ $isSelected, $isDisabled, theme }: { $isSelected?: boolean; $isDisabled?: boolean; theme: Theme }) => {
    if ($isSelected) {
      return theme.palette.primary.main
    }

    if ($isDisabled) {
      return colors.lightGrey
    }

    return colors.black
  }};
  font-weight: 500;
`

export const StyledMenuList = styled(MenuList)`
  max-height: 220px;
`
